import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@core/modals/modal-registry.token';
import { MinesInfoModalComponent } from '@features/games/mines/modals/mines-info-modal/mines-info-modal.component';

export function provideMinesModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'MinesInfoModalComponent', component: MinesInfoModalComponent }, multi: true },
  ];
}
